import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function IconArchive({
  fill = 'var(--sapphire-20)',
  width = 18,
  height = 14,
}: SvgTypesProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 4V12C16 12.5523 15.5523 13 15 13H3C2.44772 13 2 12.5523 2 12V4M16 4H2M16 4H17V2C17 1.44772 16.5523 1 16 1H2C1.44772 1 1 1.44772 1 2V4H2M12 7H6" stroke={fill} strokeWidth="1.25" strokeLinejoin="round"/>
    </svg>
  );
}
